import { Minus, Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { NEARBY_POINTS_MAX, NEARBY_POINTS_MIN } from '../schemas';

/** Figma stepper: three white bordered segments (− / value / +) with a 1px gap. */
export function NearbyPointsStepper({
  value,
  onChange,
  min = NEARBY_POINTS_MIN,
  max = NEARBY_POINTS_MAX,
  disabled,
}: {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
}) {
  const { t } = useTranslation('markets');
  const clamp = (next: number) => Math.min(max, Math.max(min, next));

  return (
    <div className="inline-flex items-center gap-px">
      <button
        type="button"
        aria-label={t('stepper.decrease')}
        disabled={disabled || value <= min}
        onClick={() => onChange(clamp(value - 1))}
        className="flex h-9 w-[42px] items-center justify-center rounded-md border border-input bg-white transition-colors hover:bg-accent disabled:opacity-50"
      >
        <Minus className="size-3.5" />
      </button>
      <span
        aria-live="polite"
        className="flex h-9 w-[66px] items-center justify-center rounded-md border border-input bg-white text-sm tabular-nums text-foreground"
      >
        {value}
      </span>
      <button
        type="button"
        aria-label={t('stepper.increase')}
        disabled={disabled || value >= max}
        onClick={() => onChange(clamp(value + 1))}
        className="flex h-9 w-[42px] items-center justify-center rounded-md border border-input bg-white transition-colors hover:bg-accent disabled:opacity-50"
      >
        <Plus className="size-3.5" />
      </button>
    </div>
  );
}
